import { modulesConfig, serviceTypes } from '../config';

export const moduleId = 'Suppliers';
export const modulePath = serviceTypes[modulesConfig.Suppliers.serviceType].path;

export const pagePaths = {
  Module: modulePath,
};
